import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataserviceService } from '../dataservice.service';
import { NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {
  w9Form: FormGroup | undefined;
  error: string | undefined;

  constructor(private fb: FormBuilder, private supabaseService: DataserviceService, private pdfViewerService: NgxExtendedPdfViewerService) {}

  ngOnInit(): void {
    this.w9Form = this.fb.group({
      name: ['', Validators.required],
      businessName: [''],
      taxClassification: ['', Validators.required],
      address: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', Validators.required],
      ssn: [''],
      ein: [''],
      signature: ['', Validators.required]
    });
    // Remove the call to renderInteractiveForms as it doesn't exist on NgxExtendedPdfViewerService
  }

  onSubmit(): void {
    if (this.w9Form!.valid) {
      // Handle form submission
      console.log(this.w9Form!.value);
    } else {
      this.error = 'Please fill out all required fields.';
    }
  }

  resetPassword() {
    
  }
}
